export default __webpack_public_path__ + "files/3b71e29959cfd65d482120e1c8094a3f.jpg";